import {useState, useEffect, useContext} from 'react';
import ajaxRequester from "../Utils/AjaxRequester.js";
import { APP } from '../Utils/Constants.js';
import {DataPageContext} from "../Context/DataPageContext.tsx";

export const useItems = (rows = 10, filterParams: Param[] = []) => {
    const [items, setItems] = useState([]);
    const [itemsStatus, setItemsStatus] = useState(APP.STATUS.LOADING);
    const [nbrItem, setNbrItem] = useState<number>(0);
    const { dataPage } = useContext(DataPageContext);

  const fetchItems = async () => {
    const goalValue = () => dataPage === 'node-page-117'
      ? 'ss_field_formation_category:qualifying'
      : 'ss_field_formation_category:qualifying_enterprise';

    const pageParam = filterParams.find(param => param.name === 'page');
    const page = pageParam ? parseInt(pageParam.value, 10) : 0 // Default to 1 if page param is not found
    let filterParamsWithoutPage = filterParams.filter(param => param.name !== 'noparam');

    // Calculate startItem
    const startItem = page - 1 > 0 ? (page - 1) * rows : 0;

    const paramsArray = [{
      name: 'fq',
      value: 'index_id:product'
    },
      {
        name: 'fq',
        value: goalValue()
      },
      {
        name: 'rows',
        value: rows,
      },
      {
        name: 'start',
        value: startItem
      },
    ]

    const hasSort = filterParams.some(param => param.name === 'sort');
    const hasSearchField = filterParams.some(param => {
        return String(param.value).includes(APP.FILTER.SEARCH.FIELD)
      }
    );

    let sortParam: { name: string; value: string; }[] = [];
    let qAllParam: { name: string; value: string; }[] = [];

    if (!hasSort) {
      if (hasSearchField) {
        sortParam = [{
          name: 'sort',
          value: 'score' + ' ' + 'DESC',
        }];

      } else {
        sortParam = [
          {
            name: 'sort',
            value: 'ss_product_title' + ' ' + 'ASC',
          }
        ];
      }
    }

    if (!hasSearchField) {
      qAllParam = [{
        name: 'q',
        value: '*:*'
      }];
    }

    const paramsMerged = [...paramsArray, ...filterParamsWithoutPage, ...sortParam, ...qAllParam];

    try {
      const response = await ajaxRequester.getFromSolr(paramsMerged);
      const data = await response.response.docs;
      const nbrItems = await response.response.numFound;
      let dataitems: any = ajaxRequester.convertSolrFormationToViewExport(data)
      setItems(dataitems);
      setNbrItem(nbrItems)
      setItemsStatus(APP.STATUS.LOADED)
    } catch (error) {
      console.error("Failed to fetch items:", error);
      // Handle the error appropriately, e.g., set an error state, show a message, etc.
    }
  }

  useEffect(() => {
    fetchItems();

  }, [filterParams]);

  return {items, itemsStatus, nbrItem};
}

